import { BULK_DELETE_MAX_CAP_FAILURE, BULK_DELETE_MAX_CAP_REQUEST, BULK_DELETE_MAX_CAP_RESET, BULK_DELETE_MAX_CAP_SUCCESS } from "redux/actions/action-type";

const initialState = {
    isBulkDeleteLoading: false,
    isBulkDeleteSuccess: false,
    isBulkDeleteFail: false,
    bulkDeleteMaxCapResponse: {},
};

export const bulkDeleteMaxCapReducer = (state = initialState, { type, bulkDeleteMaxCapResponse }) => {
    switch (type) {
        case BULK_DELETE_MAX_CAP_REQUEST:
            return {
                ...state,
                isBulkDeleteLoading: true,
                isBulkDeleteSuccess: false,
                isBulkDeleteFail: false,
            };
        case BULK_DELETE_MAX_CAP_SUCCESS:
            return {
                ...state,
                bulkDeleteMaxCapResponse: bulkDeleteMaxCapResponse,
                isBulkDeleteLoading: false,
                isBulkDeleteSuccess: true,
                isBulkDeleteFail: false,
            };
        case BULK_DELETE_MAX_CAP_FAILURE:
            return {
                ...state,
                bulkDeleteMaxCapResponse: bulkDeleteMaxCapResponse,
                isBulkDeleteLoading: false,
                isBulkDeleteSuccess: false,
                isBulkDeleteFail: true,
            };
        case BULK_DELETE_MAX_CAP_RESET:
            return { ...initialState };
        default:
            return { ...state };
    }
};
